/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'@waca/dashboard-common/js/core/APIFactory',
	'@waca/dashboard-livewidget/js/features/dashboard/queryService/api/ResultItemAPI',
	'@waca/dashboard-livewidget/js/widgets/livewidget/query/QueryResultDataItem',
	'./QueryResultColumn',
	'underscore'
], (APIFactory, ResultItemAPI, QueryResultDataItem, QueryResultColumn, _) => {
	class ResultItem extends QueryResultDataItem {
		constructor(dataItemObject) {
			super(dataItemObject);
			this.getRowCount = this.getTupleCount.bind(this);
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [ResultItemAPI]);
			}
			return this.api;
		}

		getDataItemList() {
			let resultColumnList = this.getTupleHeaders()[0];
			return _.map(resultColumnList, columnObj => (new QueryResultColumn(columnObj)).getAPI());
		}

		getId() {
			return this._getTupleHeaderObjects()[0].id;
		}

		//TODO: delete memberObj.u and memberObj.d when all consumers are ready to new qeury APIs
		getValue(rowIndex) {
			let tuple = this.getTuple(rowIndex);
			tuple.forEach(memberObj => {
				if(memberObj.value === undefined){
					memberObj.value =  memberObj.u;
					memberObj.label = memberObj.d;
				}
			});
			return tuple;
		}
	}

	return ResultItem;
});
